import Dialog from "../../../atoms/dialog";
import CloneView from "../../../molecules/dashboardBuilder/CloneView";

const CloneViewAlert = ({ onClose }) => {

    const handleClose = () => {
        onClose()
    }

    return (
        <Dialog
            title={"Clone"}
            open={true}
            handleClose={handleClose}
        >

            <CloneView onClose={onClose} />

        </Dialog >
    )

}

export default CloneViewAlert;